<template lang="html">
  <div class="document-page">
    <Banner
      size="small"
      :imageCoverURL="baseUrlStorage+entrevista.background"
      :title="entrevista.title"

    />
    <div class="container py-5">
      <div class="content py-5">
        <div class="row mt-5">
          <div class="col-12 col-md-9">
            <div class="title-general">
              <TextDocument textType="title" textAlign="left"
                >{{ entrevista.description }}</TextDocument
              >
            </div>
            <p class="indication">Krauth, C (2013)</p>
            <span>
              {{ entrevista.place }}
            </span>
            <p :v-if="entrevista.link">
              <span > Link del video: </span> <br />
              <a
                :href="entrevista.link"
                target="_blank"
              >
                {{ entrevista.link }}</a
              >
            </p>
            <div class="ficha">
              <div class="video">
                <VideoPlayer 
                  :videoEmbedURL="baseUrlStorage+entrevista.file ? baseUrlStorage+entrevista.file :entrevista.link"
                />
              </div>
            </div>
          </div>
          <div class="col-12 col-md-1"></div>
          <div class="col-12 col-md-2 my-4 my-md-0">
            <ButtonsDocument />
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Banner from "../components/General/Banner.vue";
import Footer from "../components/General/Footer.vue";
import TextDocument from "../components/Document/TextDocument.vue";
import ButtonsDocument from "../components/Document/ButtonsDocument.vue";
import VideoPlayer from '../components/VideoPlayer.vue';

import { mapState, mapActions } from "vuex";

export default {
  inject: ['baseUrlStorage'],
  components: {
    Banner,
    Footer,
    VideoPlayer,
    TextDocument,
    ButtonsDocument,
  },
  data() {
    return {
      entrevista:{},
    }
  },
  computed: {
    ...mapState({
      data: (state) => state.dataIntreview,
    }),
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions(["getDataAdmin"]),
    getData() {
      var _this = this;
      this.getDataAdmin({
        url: "getIntreview",
        type: "POST",
        params: { },
      }).then(
        (res) => {
          console.log(res.data);
          _this.entrevista = res.data;
          this.$store.commit("SET_DATA_INTREVIEW", {
            data: res.data,
          });
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
};
</script>
<style lang="css" scoped>
.document-page {
  background: #eef0f4;
}
.document-page .title-general {
  margin-bottom: 58px;
}
.document-page .autor-place {
  margin-bottom: 28px;
}
.document-page .ficha {
  margin: 30px 0;
}
.document-page .ficha .title {
  margin-bottom: 15px;
}
.document-page .ficha .content {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.document-page .caso {
  margin: 30px 0;
}
.document-page .caso .title {
  margin-bottom: 15px;
}
.document-page .caso .content {
  margin-bottom: 10px;
}
.document-page .pregunta {
  margin-top: 80px;
}
.document-page .pregunta .title {
  margin-bottom: 15px;
}
.document-page .pregunta .content {
  margin-bottom: 2px;
}
.document-page .content .pagination {
  display: flex;
  justify-content: center;
  margin: 40px 0;
}
.video {
  position: relative;
  margin-top: 30px;
}
.play {
  position: absolute;
  left: 40%;
  top: 38%;
  font-size: 100px;
  color: white;
  cursor: pointer;
}
.video img {
  border-radius: 10px;
  width: 100%;
}
span {
  font-family: Roboto;
  font-size: 15px;
  font-weight: 700;
  line-height: 19px;
  letter-spacing: 0em;
  text-align: left;
  color: #696f72;
}

.indication {
  font-family: Work Sans;
  font-size: 13px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
  text-transform: uppercase;
}
</style>
